module.exports = __webpack_public_path__ + "img/img_02.3cb69789.png";